import React, { Component } from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import { Button } from "react-bootstrap";

const SaveButton = () => {
  const dispatch = useDispatch();
  const {action, saving} = useSelector(state => state.ui);

  const buttonText = () => {
    if (saving) {
      return "Saving...";
    }
    if (action === "show") {
      return "Edit";
    }
    return "Save";
  }

  const openModal = () => {
    dispatch({ type: "TOGGLE_ACTION" })
  }

  return (
    <Button
      size="sm"
      onClick={() => openModal()}
      disabled={saving}
      className="save-button">
      {buttonText()}
    </Button>
  );
}

export default SaveButton;
